import React from 'react'

const CheckedWhite = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.95852 9.64587C4.84741 9.64587 4.74324 9.62837 4.64602 9.59337C4.54879 9.55893 4.45852 9.50004 4.37518 9.41671L0.79185 5.83337C0.639073 5.6806 0.566017 5.48254 0.572684 5.23921C0.579906 4.99643 0.659906 4.79865 0.812683 4.64587C0.965461 4.4931 1.15991 4.41671 1.39602 4.41671C1.63213 4.41671 1.82657 4.4931 1.97935 4.64587L4.95852 7.62504L12.021 0.562541C12.1738 0.409763 12.3719 0.333374 12.6152 0.333374C12.858 0.333374 13.0557 0.409763 13.2085 0.562541C13.3613 0.715319 13.4377 0.913096 13.4377 1.15587C13.4377 1.39921 13.3613 1.59726 13.2085 1.75004L5.54185 9.41671C5.45852 9.50004 5.36824 9.55893 5.27102 9.59337C5.17379 9.62837 5.06963 9.64587 4.95852 9.64587Z"
        fill="white"
      />
    </svg>
  )
}

export default CheckedWhite
